module.exports = {"unknown":{"header":"Something went wrong","content":"We’re experiencing some technical issues at the moment. Please try again later"},"duplicateAccount":{"header":"Seems like you already have an account","content":"You can login or\ntry another email","action":"Change email"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/error.json
// module id = 639
// module chunks = 247 1455